import chroma from 'chroma-js'

export function getCSSVariable(variable: string): string {
  return window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
}

function compareAndReturnDarker(color1: string, color2: string): string {
  const luminance1 = chroma(color1).luminance()
  const luminance2 = chroma(color2).luminance()
  return luminance1 < luminance2 ? color1 : color2
}

export function checkIsSideBackgroundDark(): boolean {
  const sidebarBackground = getCSSVariable('--sidebar-background').trim()
  const secondary = getCSSVariable('--sidebar-background-gradient').trim()

  return (
    compareAndReturnDarker(sidebarBackground, secondary) === sidebarBackground
  )
}
